<template>
  <div>
    <div>
      <el-button type="primary" plain @click="addUser">新增用户</el-button>
      <el-input
        style="width: 200px"
        placeholder="用户名筛选"
        v-model="username"
      ></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="真实姓名">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构ID">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.orgId }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="name == 'admin'"
          align="center"
          label="是否开启统计"
          width="180"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.openStat"
              @change="changeOpenStat(scope.$index, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center" label="创建日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="修改日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="warning"
              @click="handleRe(scope.$index, scope.row)"
              >重置密码</el-button
            >
            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
            <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="120px">
        <el-form-item label="用户名" required>
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item  v-if="name == 'admin'" label="用户组">
          <el-select   v-model="form.grp" placeholder="请选择">
            <el-option label="超级管理员" :value="1" disabled></el-option>
            <el-option label="省级管理员" :value="2"></el-option>
            <el-option label="普通管理员" :value="3"></el-option>
            <el-option label="医院管理员" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="name == 'admin'"  label="是否开启统计">
          <el-switch   v-model="form.openStat"></el-switch>
        </el-form-item>
        <el-form-item v-if="diaName != '修改用户'" label="密码">
          <el-input v-model="form.password" required></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.realName"></el-input>
        </el-form-item>
        <el-form-item label="机构" required>
          <tree-select
            :treeValue="treeValue"
            @treeValue="getTree"
            style="width: 200px"
            v-if="tree"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  mounted() {
    this.name = sessionStorage.getItem("admin");
    if(this.name=='admin'){
      this.grp=3
       this.openStat=false
    }else{
      this.grp = sessionStorage.getItem("grp");
     this.openStat = sessionStorage.getItem("openStat")==1?true:false;
    }
    this.load();
  },
  data() {
    return {
      grp:0,
      openStat:0,
      name: "",
      username: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogVisible: false,
      tree: false,
      treeOption: [],
      form: {
        username: "", //用户名
        password: "", //密码
        realName: "", //真实姓名
        orgId: "", //机构ID
        openStat: false,
        grp: 3,
      },
      treeValue: null,
      diaName: "新增用户",
    };
  },
  methods: {
    //获取医院code
    getTree(x) {
      this.form.orgId = x;
    },
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.diaName = "新增用户";
      this.treeValue = Number(sessionStorage.getItem("orgId"));
      this.form = {
        username: "", //用户名
        password: "", //密码
        realName: "", //真实姓名
        orgId: "", //机构ID
        openStat: this.openStat,
        grp: Number(this.grp),
      };
      this.dialogVisible = true;
      this.tree = false;
      this.form.orgId = sessionStorage.getItem("orgId");
      this.$api.structureList().then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.tree = true;
          this.treeOption = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    add() {
      console.log(this.form);
      this.$api
        .addUpdataUser(this.form)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(index, row) {
      this.diaName = "修改用户";
      this.treeValue = row.orgId;
      this.form.username = row.username;
      this.form.password = "";
      this.form.id = row.id;
      this.form.realName = row.realName;
      this.form.orgId = row.orgId;
      this.form.openStat = row.openStat;
      this.form.grp = row.grp;
      this.dialogVisible = true;
      this.tree = false;
      this.$api.structureList().then((res) => {
        if (res.data.code == 200) {
          this.tree = true;
          this.treeOption = res.data.data;
        }
      });
      // console.log(index, row);
    },
    //重置密码
    handleRe(index, row) {
      this.$prompt("请输入新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          // console.log(row.id, value);
          this.$api
            .updatePwd({
              id: row.id,
              password: value,
            })
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });

      console.log(index, row);
    },
    //删除用户
    handleDelete(index, row) {
      console.log(row.id);
      this.$api.userDelete(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      console.log(index, row);
    },
    //是否开启统计
    changeOpenStat(index, row) {
      // console.log(index,row)
      let obj = {
        id: row.id,
        openStat: row.openStat,
      };
      this.$api
        .addUpdataUser(obj)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        username: this.username,
      };
      console.log(obj);
      this.$api.getList(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>